import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/v1/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
    disableBackButton: true,
  },
  {
    path: "/v1/options",
    name: "options",
    component: () => import("../views/PaymentOptionsView.vue"),
    disableBackButton: true,
  },
  {
    path: "/v1/payment",
    name: "payment",
    component: () => import("../views/PaymentInfo.vue"),
    disableBackButton: true,
  },
  {
    path: "/v1/paymentresult",
    name: "paymentresult",
    component: () => import("../views/PaymentResult.vue"),
  },
  {
    path: "/v1/EcashUI",
    name: "EcashUI",
    component: () => import("../views/EcashUIVue.vue"),
  },
  {
    path: "/v1/MtnPayment",
    name: "MtnPayment",
    component: () => import("../views/MtnPayment.vue"),
  },
  {
    path: "/v1/hometest",
    name: "hometest",
    component: () => import("../views/HomeTest.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  window.history.forward();
  next();
});

export default router;
